import { useMemo } from 'react'

import { TreeSelect } from 'antd'
import { useSelector } from 'react-redux'

import { States, StateTypes } from '../../../../utils/entities/internshipRequest'
import { selectTranslate } from '../../../../reducers/LocaleReducer/LocalReducer'

const { SHOW_PARENT } = TreeSelect

const RequestStateCheckbox = ({ value, onCheck }) => {
  const t = useSelector(selectTranslate)

  const treeData = useMemo(() => [
    {
      title: t('internship_request.status.closed'),
      value: StateTypes.CLOSED.key,
      key: '0',
      children: [
        { title: t('internship_request.status.accepted'), value: States.ACCEPTED, key: '0-0' },
        { title: t('internship_request.status.refused'), value: States.REFUSED, key: '0-1' }
      ]
    },
    {
      title: t('internship_request.status.open'),
      value: StateTypes.OPEN.key,
      key: '1',
      children: [
        { title: t('internship_request.status.incomplete'), value: States.INCOMPLETE, key: '1-0' },
        { title: t('internship_request.status.on_hold'), value: States.ON_HOLD, key: '1-1' },
        { title: t('internship_request.status.action_required'), value: States.ACTION_REQUIRED, key: '1-2' }
      ]
    }
  ], [])

  return (
    <TreeSelect
      treeData={treeData}
      value={value}
      onChange={onCheck}
      dropdownStyle={{ maxHeight: '200px' }}
      placement='bottom'
      treeCheckable
      showSearch={false}
      showCheckedStrategy={SHOW_PARENT}
      style={{ width: '100%' }}
    />
  )
}

export default RequestStateCheckbox
